import React from 'react';
import { Box } from '@mui/material';

const funnelStages = [
  { stage: 'packed', label: 'To be packed', count: 3 },
  { stage: 'shipped', label: 'To be shipped', count: 3 },
  { stage: 'delivered', label: 'To be delivered', count: 2 },
  { stage: 'done', label: 'Delivered', count: 2 },
];

export default function FulfilmentFunnelCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Fulfilment Funnel</h3>
        <span className="click-tag">Click rows for order details</span>
      </div>
      <div id="opsFunnel" className="funnel" style={{ height: '220px', overflow: 'auto' }}>
        {funnelStages.map((stage) => (
          <Box
            key={stage.stage}
            className="funnel-row"
            data-stage={stage.stage}
            onClick={() => window.opsFunnelClick?.(stage.stage)}
          >
            <div className="funnel-label">{stage.label}</div>
            <div className="funnel-bar-bg">
              <div className="funnel-bar inline-style-15" style={{ width: `${(stage.count / 3) * 100}%` }}>
                {stage.count}
              </div>
            </div>
          </Box>
        ))}
      </div>
    </Box>
  );
}
